export default {"src":"/_next/static/media/IconPartsProtection.ebe53db8.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};